import { render, staticRenderFns } from "./default.vue?vue&type=template&id=68a20270"
var script = {}
import style0 from "./default.vue?vue&type=style&index=0&id=68a20270&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports